import { SEC_ApiCall, SEC_DataApiPost } from '../func';

/** Reject malformed System Manager OnCall API responses. */
function validateResponse(response) {
  if (!response || typeof response !== 'object' || response.message) {
    throw new Error(response?.message || 'Invalid System Manager OnCall response');
  }
  return response;
}

/** Load OnCall types, configured SLT staff, and active staff. */
export async function getOnCallAdminData() {
  const response = validateResponse(await SEC_ApiCall('sysmanager/oncall'));
  if (!Array.isArray(response.onCallType) || !Array.isArray(response.onCallSlt) || !Array.isArray(response.activeStaff) || !Array.isArray(response.pupilGroups)) {
    throw new Error('Unexpected System Manager OnCall response shape');
  }
  return response;
}

/** Save one staff member's class, pupil-group, or whole-school report scope. */
export async function saveOnCallReportScope(payload) {
  return validateResponse(await SEC_DataApiPost(
    'sysmanager/staff/permission-overrides/update',
    JSON.stringify({ action: 'updateOnCallReportScope', ...payload }),
    {},
  ));
}

/** Replace the school's OnCall type configuration. */
export async function saveOnCallTypes(onCallType) {
  return validateResponse(await SEC_DataApiPost(
    'sysmanager/oncall/types',
    JSON.stringify({ onCallType }),
    {},
  ));
}

/** Replace the active staff available to the OnCall assignment controls. */
export async function saveOnCallSlt(onCallSlt) {
  return validateResponse(await SEC_DataApiPost(
    'sysmanager/oncall/assignableStaff',
    JSON.stringify({ onCallSlt }),
    {},
  ));
}
